'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _TwoWayTransition = require('./TwoWayTransition');

var _TwoWayTransition2 = _interopRequireDefault(_TwoWayTransition);

var _Functions = require('../core/Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var AccordionTransitionWrapper = (0, _styledComponents2.default)(function (_ref) {
  var open = _ref.open,
      __measuredHeight = _ref.measuredHeight,
      transitioning = _ref.transitioning,
      rest = _objectWithoutProperties(_ref, ['open', 'measuredHeight', 'transitioning']);

  return _react2.default.createElement(_TwoWayTransition2.default.PlainWrapper, _extends({
    'data-open-complete': open && !transitioning
  }, rest));
}).withConfig({
  displayName: 'AccordionTransition__AccordionTransitionWrapper'
})(['transition:', ';height:', ';opacity:', ';pointer-events:', ';transform:', ';overflow:hidden;'], function (_ref2) {
  var duration = _ref2.duration,
      measuredHeight = _ref2.measuredHeight,
      transitionActive = _ref2.transitionActive;
  return measuredHeight != null && transitionActive ? 'height ' + duration + 'ms cubic-bezier(0.25, 0.1, 0.25, 1),\n    opacity ' + duration + 'ms cubic-bezier(0.42, 0, 0.58, 1),\n    transform ' + duration + 'ms cubic-bezier(0.42, 0, 0.58, 1)' : 'none';
}, function (_ref3) {
  var open = _ref3.open,
      measuredHeight = _ref3.measuredHeight,
      transitioning = _ref3.transitioning;
  return transitioning && (open ? measuredHeight + 'px' : 0);
}, function (_ref4) {
  var open = _ref4.open,
      transitioning = _ref4.transitioning;
  return transitioning && (open ? 1 : 0);
}, function (_ref5) {
  var transitioning = _ref5.transitioning;
  return transitioning && 'none';
}, function (_ref6) {
  var open = _ref6.open,
      transitioning = _ref6.transitioning;
  return transitioning && 'translateY(' + (open ? '0' : '-10px') + ')';
});

var AccordionTransition = function (_PureComponent) {
  _inherits(AccordionTransition, _PureComponent);

  function AccordionTransition(props) {
    _classCallCheck(this, AccordionTransition);

    var _this = _possibleConstructorReturn(this, (AccordionTransition.__proto__ || Object.getPrototypeOf(AccordionTransition)).call(this, props));

    _this.handleTransitionStart = function () {
      _this.setState({ transitioning: true });
    };

    _this.handleTransitionComplete = function () {
      _this.setState({ transitioning: false });
    };

    _this.state = {
      measuredHeight: 0, // 0 = not needed, null = needed
      transitioning: false
    };
    return _this;
  }

  _createClass(AccordionTransition, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.open !== nextProps.open && !this.state.transitioning) {
        this.setState({ measuredHeight: null });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.state.measuredHeight == null) {
        this.measureHeight();
      }
    }
  }, {
    key: 'measureHeight',
    value: function measureHeight() {
      var el = (0, _reactDom.findDOMNode)(this);
      if (!el) return;
      this.setState({ measuredHeight: el.scrollHeight });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          Content = _props.Content,
          duration = _props.duration,
          onOpenStart = _props.onOpenStart,
          onCloseStart = _props.onCloseStart,
          onOpenComplete = _props.onOpenComplete,
          onCloseComplete = _props.onCloseComplete,
          open = _props.open,
          rest = _objectWithoutProperties(_props, ['children', 'Content', 'duration', 'onOpenStart', 'onCloseStart', 'onOpenComplete', 'onCloseComplete', 'open']);

      var renderedContent = null;
      if (open) {
        renderedContent = Content ? _react2.default.createElement(Content, null) : children;
      }

      return _react2.default.createElement(
        _TwoWayTransition2.default,
        _extends({}, rest, {
          duration: duration,
          measuredHeight: this.state.measuredHeight,
          onOpenStart: (0, _Functions.memoizedSequence)(this.handleTransitionStart, onOpenStart),
          onCloseStart: (0, _Functions.memoizedSequence)(this.handleTransitionStart, onCloseStart),
          onOpenComplete: (0, _Functions.memoizedSequence)(this.handleTransitionComplete, onOpenComplete),
          onCloseComplete: (0, _Functions.memoizedSequence)(this.handleTransitionComplete, onCloseComplete)
        }),
        renderedContent
      );
    }
  }]);

  return AccordionTransition;
}(_react.PureComponent);

AccordionTransition.propTypes = {
  children: _propTypes2.default.node,
  Content: _propTypes2.default.elementType,
  duration: _propTypes2.default.number.isRequired,
  onCloseComplete: _propTypes2.default.func,
  onCloseStart: _propTypes2.default.func,
  onOpenComplete: _propTypes2.default.func,
  onOpenStart: _propTypes2.default.func,
  open: _propTypes2.default.bool.isRequired,
  Wrapper: _propTypes2.default.elementType.isRequired
};

AccordionTransition.defaultProps = {
  duration: 200,
  Wrapper: AccordionTransitionWrapper
};

AccordionTransition.displayName = 'AccordionTransition';

exports.default = AccordionTransition;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/transitions/AccordionTransition.js
// module id = 218
// module chunks = 177